import React, { useEffect, useRef, useState, useCallback } from 'react';
import { any, array, bool, func, object, string } from 'prop-types';
import classNames from 'classnames';

import Button from 'components/Button';
import View from 'components/Icon/View';

export default function TextField({ defaultValue, className, disabled, errors, label, onChange, onBlur, multiline, name, placeholder, readOnly, style, Icon, type, value, test }) {
  const inputRef = useRef(null);
  const [showPwd, setShowPwd] = useState(false);
  const rightType = type === 'password' ? (showPwd ? 'text' : type) : type;
  const error = errors && errors.length > 0 ? errors.join(', ') : undefined;
  const Input = multiline ? 'textarea' : 'input';
  const onToggleType = useCallback((event) => {
    event.preventDefault();
    setShowPwd(current => !current);
    // Setting focus
    inputRef.current.focus();
  }, []);
  useEffect(() => {
    // Moving cursor to the end
    if (type === 'password') {
      inputRef.current.selectionStart = inputRef.current.value.length;
      inputRef.current.selectionEnd = inputRef.current.value.length;
    }
  }, [type, showPwd]);
  
  return (
    <label className={classNames('Texfield block', className, { 'TextArea': multiline })} data-test={test}>
      {label && <span className="block mb-1 text-secondary text-sm font-sans">{label}:</span>}
      <div className="Texfield_input flex pl-4 bg-neutral rounded border-b border-neutral-light focus-within:border-primary focus-within:bg-neutral-light" style={style}>
        { Icon && 
          <div className="pt-2 pr-2">
            <Icon width={16} height={16} className="fill-current text-default" />
          </div>
        }
        <Input
          ref={inputRef}
          type={rightType}
          name={name}
          placeholder={placeholder}
          className="flex-1 pr-4 py-2 bg-transparent text-default text-sm focus:outline-none"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          defaultValue={defaultValue}
        />
        {type === 'password' &&
          <Button type="icon" onClick={onToggleType} element="div">
            <View width={16} height={16} />
          </Button>
        }
      </div>
      {error && <p className="text-primary text-sm">{error}</p>}
    </label>
  );
}

TextField.propTypes = {
  defaultValue: string,
  disabled: bool,
  readOnly: bool,
  style: object,
  errors: array,
  className: string,
  label: string,
  multiline: bool,
  name: string,
  placeholder: string,
  test: string,
  type: string,
  onChange: func,
  onBlur: func,
  value: any,
};

TextField.defaultProps = {
  multiline: false,
  type: 'text',
};
